<template>
    <div class="sidebar-inner">
        <!-- Top Section -->
        <div class="top-section">
            <h4 v-if="!isLoadingExpenses" class="mb-1">Expenses</h4>
            <h4 v-if="isLoadingExpenses" class="mb-1">Loading Expenses...</h4>
            <hr>

            <!-- Is Loading -->
            <div class="text-center mt-4" v-if="isLoadingExpenses">
                <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
            </div>
            <!-- / Is Loading -->

            <!-- Loaded -->
            <div v-if="!isLoadingExpenses && (expenses == null || expenses.length == 0)">
                <div class="axum-data mt-3">
                    <div class="property-card">
                        <b class="property-name text-danger">
                            No expenses to show
                        </b>
                    </div>
                </div>
            </div>
            <!-- / Loaded -->

            <!-- Has Expenses-->
            <div v-if="!isLoadingExpenses && expenses && expenses.length">
                <expense v-for="expense in expenses" @expense-deleted="loadExpenses" @expense-updated="loadExpenses"
                    :key="`expense-${expense.id}`" :expense="expense"></expense>
            </div>
            <!-- / Has Expenses-->
        </div>
        <!-- / Top Section -->
        <!-- Bottom Section -->
        <div class="bottom-section pt-3 pb-3">
            <create-expense-modal @expense-added="loadExpenses" :ticket-id="ticket.id">
            </create-expense-modal>
            <a href="#" @click.prevent="openCreateExpenseModal" class="btn btn-itg-dark btn-block"
                :class="{ 'disabled': isLoadingExpenses }">
                <i class="fa fa-plus mr-1"></i>
                Create Expense
            </a>
        </div>
        <!-- / Bottom Section -->
    </div>
</template>

<script>
import CreateExpenseModal from './ExpensesSidebar/CreateExpenseModal.vue';
import Expense from './ExpensesSidebar/Expense.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
    components: { CreateExpenseModal, Expense },
    data() {
        return {}
    },
    created() {
        this.loadExpenses();
    },
    computed: {
        ...mapGetters('ticketViewer', {
            ticket: 'ticket',
            isLoadingExpenses: 'isLoadingExpenses',
            expenses: 'expenses'
        })
    },
    methods: {
        ...mapActions('ticketViewer', {
            loadExpenses: 'loadExpenses'
        }),

        openCreateExpenseModal() {
            this.$bvModal.show('create-expense-modal');
        }
    }
}
</script>

<style scoped lang="scss">
.property-card {
    background: #fff;
    border-radius: 5px;
    padding: 15px;

    .property-name {
        font-weight: 600;
        color: #2c5cc5;
    }
}
</style>